<template>
  <div id="personal">
    <div class="tit-rit">公司信息</div>
    <div class="el-pass-cont">
      <div class="el-sub-personal">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="formLabelAlign"
          :rules="rules"
          ref="formLabelAlign"
        >
          <el-form-item label="用户名称" prop="name">
            <el-input v-model="formLabelAlign.name" disabled></el-input>
          </el-form-item>
          <!-- <el-form-item label="负责人" prop="people">
            <el-input v-model="formLabelAlign.people"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="formLabelAlign.phone"></el-input>
          </el-form-item> -->
          <el-form-item label="邮箱账号" prop="email">
            <el-input v-model="formLabelAlign.email" disabled></el-input>
            <!-- <el-button type="primary" @click="centerDialogVisible = true">
              绑定 / 修改邮箱
            </el-button> -->
          </el-form-item>
          <!-- <el-form-item label="企业名称" prop="compName">
            <el-input v-model="formLabelAlign.compName"></el-input>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button type="primary" @click="submitForm('formLabelAlign')">
              提 交
            </el-button>
          </el-form-item> -->
        </el-form>
      </div>
      <el-dialog
        title="修改邮箱"
        :visible.sync="centerDialogVisible"
        width="400px"
      >
        <div class="el-xg-emial">
          <p>
            <el-input v-model="regEmail" :placeholder="placeholder"></el-input>
          </p>
          <p>
            <el-input
              v-model="yzEmial"
              placeholder="请输入邮箱验证码"
              style="width: 235px"
            ></el-input>
            <el-button type="primary" :loading="loadings" @click="resNewemail"
              >{{ regbutxt }} <span v-if="loadings">s</span></el-button
            >
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="tjEamail">确 定</el-button>
          <el-button @click="closeTjeamail">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  isvalidUsername,
  isvalidPhone,
  isvalidEmail,
} from "../resgiter/reg/validation.js";
export default {
  name: "Personal",
  data() {
    let validUsername = (rule, value, callback) => {
      //校验用户名
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (!isvalidUsername(value)) {
        callback(new Error("用户名为4-16个字母或数字"));
      } else {
        callback();
      }
    };
    let validPhone = (rule, value, callback) => {
      //校验手机号
      if (value === "") {
        callback(new Error("请输入联系方式"));
      } else if (!isvalidPhone(value)) {
        callback(new Error("请规范联系方式"));
      } else {
        callback();
      }
    };
    let validEmail = (rule, value, callback) => {
      //校验邮箱账号
      if (value === "") {
        callback(new Error("请输入邮箱账号"));
      } else if (!isvalidEmail(value)) {
        callback(new Error("请规范邮箱账号"));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "right",
      formLabelAlign: {
        name: "--",
        people: "--",
        phone: "--",
        email: "--",
        compName: "--",
      },
      rules: {
        name: [{ required: true, validator: validUsername, trigger: "blur" }],
        people: [{ required: true, message: "请输入负责人", trigger: "blur" }],
        phone: [{ required: true, validator: validPhone, trigger: "blur" }],
        email: [{ required: true, validator: validEmail, trigger: "blur" }],
        compName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
      },
      regEmail: "",
      // regEmail: [{ required: true, validator: validEmail, trigger: "blur" }],
      yzEmial: "",
      loadings: false,
      regbutxt: "发送验证码",
      placeholder: "请输入新的邮箱账号",
      timer: null,
      checktoken: "",
      centerDialogVisible: false,
    };
  },
  mounted() {
    this.msgDatas();
  },
  watch: {},
  methods: {
    //获取数据
    msgDatas() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("Myinfo/index", {
          token: tokens,
        })
        .then((res) => {
          this.formLabelAlign.name = res.data.data.username;
          this.formLabelAlign.people = res.data.data.linkman;
          this.formLabelAlign.phone = res.data.data.phone;
          this.formLabelAlign.email = res.data.data.email;
          this.formLabelAlign.compName = res.data.data.crop_name;
        })
        .catch((err) => {
          this.$message({
            message: "数据异常，请稍后再试！", //弹出返回信息
            type: "warning",
            offset: 150,
          });
        });
    },
    //修改数据
    ModifyDatas() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("Myinfo/updateInfo", {
          token: tokens,
          username: this.formLabelAlign.name,
          linkman: this.formLabelAlign.people,
          phone: this.formLabelAlign.phone,
          crop_name: this.formLabelAlign.compName,
          email: this.formLabelAlign.email,
        })
        .then((res) => {
          this.$message({
            message: res.data.msg, //弹出返回信息
            type: "success",
            offset: 150,
          });
          this.$router.go(0);
        })
        .catch((err) => {
          this.$message({
            message: "数据异常，请稍后再试！", //弹出返回信息
            type: "warning",
            offset: 150,
          });
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ModifyDatas();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //修改邮箱账号
    resNewemail() {
      const timecont = 59;
      let token = localStorage.getItem("token");
      let userName = localStorage.getItem("username");
      let userPass = localStorage.getItem("password");
      if (!this.timer) {
        this.regbutxt = timecont;
        this.loadings = true;
        this.timer = setInterval(() => {
          if (this.regbutxt > 1 && this.regbutxt <= timecont) {
            this.regbutxt--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
            this.loadings = false;
            this.regbutxt = "发送验证码";
          }
        }, 1000);
      }
      this.$axios
        .post("login/sendEmailCode", {
          username: userName,
          password: userPass,
          email: this.regEmail,
        })
        .then((res) => {
          this.$message({
            message: res.data.msg, //弹出返回信息
            offset: 150,
          });
          this.checktoken = res.data.data.checktoken;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    tjEamail() {
      let tokens = localStorage.getItem("token");
      this.$axios
        .post("Myinfo/updateEmail", {
          token: tokens,
          email: this.regEmail,
          checktoken: this.checktoken,
          emailCode: this.yzEmial,
        })
        .then((res) => {
          this.centerDialogVisible = false;
          this.msgDatas();
          this.$message({
            message: res.data.msg, //弹出返回信息
            offset: 150,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closeTjeamail() {
      this.centerDialogVisible = false;
      this.regEmail = "";
      this.yzEmial = "";
    },
  },
};
</script>
<style>
  .el-form-item__label {
    font-size: 15px;
  }
</style>
<style scoped>
@import "./coms/user.css";
</style>>



// WEBPACK FOOTER //
// src/components/user/personal_user.vue